'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["showCredentials"];
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UsernamePassword from '../component/UsernamePassword';
import HostField from '../component/HostField';
import PortField from '../component/PortField';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';
const ImapServerSettings = props => {
  const {
      showCredentials
    } = props,
    sharedProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockStart: "1000",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${LANG_ROUTE}.incomingServer.heading`
      })
    }), showCredentials ? /*#__PURE__*/_jsx(UsernamePassword, Object.assign({}, sharedProps, {
      userFieldName: "customUsername",
      passwordFieldName: "password"
    })) : null, /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(HostField, Object.assign({}, sharedProps, {
        baseLangKey: "incomingServer",
        fieldName: "imapHost"
      })), /*#__PURE__*/_jsx(PortField, Object.assign({}, sharedProps, {
        baseLangKey: "incomingServer",
        fieldName: "imapPort"
      }))]
    }), /*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockStart: "1000",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${LANG_ROUTE}.outgoingServer.heading`
      })
    }), showCredentials ? /*#__PURE__*/_jsx(UsernamePassword, Object.assign({}, sharedProps, {
      userFieldName: "smtpUsername",
      passwordFieldName: "smtpPassword"
    })) : null, /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(HostField, Object.assign({}, sharedProps, {
        baseLangKey: "outgoingServer",
        fieldName: "smtpHost"
      })), /*#__PURE__*/_jsx(PortField, Object.assign({}, sharedProps, {
        baseLangKey: "outgoingServer",
        fieldName: "smtpPort"
      }))]
    })]
  });
};
ImapServerSettings.propTypes = {
  showCredentials: PropTypes.bool.isRequired,
  fieldProps: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};
export default ImapServerSettings;